import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-search-select/dist/VueSearchSelect.css';

import Vue from 'vue';
import Router from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import { TokenService } from './services/TokenService';
import { TokenInfo } from './models/TokenInfo';
import { ZgRouterFactory } from './models/ZgRouterFactory';
import { ZgAppFactory } from './models/ZgAppFactory';
import vClickOutside from 'v-click-outside';
import MySmartway from './views/mysmartway/MySmartway'

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Router);
Vue.use(vClickOutside);


TokenService.SaveTokenLocal();
const tokenService = new TokenService();
tokenService.GetInfo().then(
    (tokenInfo: TokenInfo) => {

        const router = ZgRouterFactory.GetCorrectRouterByToken(tokenInfo);
        const app = ZgAppFactory.GetCorrectAppByToken(tokenInfo);
        new Vue({
            router,
            render: (h) => h(app),
        }).$mount('#app');
    },
    MySmartway,
);
